import { Overlay, ScrollStrategyOptions } from '@angular/cdk/overlay';
import { Component, Inject, OnInit, ViewContainerRef } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { User } from 'src/app/core/models/user';

@Component({
  selector: 'app-profile-modal',
  templateUrl: './profile-modal.component.html',
  styleUrls: ['./profile-modal.component.scss']
})
export class ProfileModalComponent implements OnInit {
  currentIndex: any = -1;
  showFlag: any = false;
  user: User;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, protected overlay: Overlay,
    protected scrollStrategyOptions: ScrollStrategyOptions,
    protected viewContainerRef: ViewContainerRef) {
    this.user = data;

  }

  ngOnInit(): void {
  }
  imageObject: Array<object> = [
    {
      image: 'assets/images/image-gallery/1.jpg',
      thumbImage: 'assets/images/image-gallery/1.jpg',
      title: 'Image 1',
    },
    {
      image: 'assets/images/image-gallery/2.jpg',
      thumbImage: 'assets/images/image-gallery/2.jpg',
      title: 'Image 2',
    },
    {
      image: 'assets/images/image-gallery/3.jpg',
      thumbImage: 'assets/images/image-gallery/3.jpg',
      title: 'Image 3',
    },
    {
      image: 'assets/images/image-gallery/4.jpg',
      thumbImage: 'assets/images/image-gallery/4.jpg',
      title: 'Image 4',
    },
    {
      image: 'assets/images/image-gallery/5.jpg',
      thumbImage: 'assets/images/image-gallery/5.jpg',
      title: 'Image 5',
    },
    {
      image: 'assets/images/image-gallery/6.jpg',
      thumbImage: 'assets/images/image-gallery/6.jpg',
      title: 'Image 6',
    },
    {
      image: 'assets/images/image-gallery/7.jpg',
      thumbImage: 'assets/images/image-gallery/7.jpg',
      title: 'Image 7',
    },
    {
      image: 'assets/images/image-gallery/8.jpg',
      thumbImage: 'assets/images/image-gallery/8.jpg',
      title: 'Image 8',
    },
    {
      image: 'assets/images/image-gallery/9.jpg',
      thumbImage: 'assets/images/image-gallery/9.jpg',
      title: 'Image 9',
    },
    {
      image: 'assets/images/image-gallery/10.jpg',
      thumbImage: 'assets/images/image-gallery/10.jpg',
      title: 'Image 10',
    },
    {
      image: 'assets/images/image-gallery/11.jpg',
      thumbImage: 'assets/images/image-gallery/11.jpg',
      title: 'Image 11',
    },
    {
      image: 'assets/images/image-gallery/12.jpg',
      thumbImage: 'assets/images/image-gallery/12.jpg',
      title: 'Image 12',
    },
  ];

  showLightbox(index) {
    this.currentIndex = index;
    this.showFlag = true;
  }

  closeEventHandler() {
    this.showFlag = false;
    this.currentIndex = -1;
  }
}
